module.exports = __webpack_public_path__ + "img/failure.2cf1840d.svg";